export const buildGeocodeCacheKey = (countryCode, location) => {
  return `${countryCode}|${location.toLowerCase()}`;
};

export const groupKeywordsByLocation = (keywordEntries) => {
  const byLocation = {};
  keywordEntries.forEach((entry) => {
    if (!entry.location) return;
    const key = entry.location.toLowerCase();
    if (!byLocation[key]) {
      byLocation[key] = [];
    }
    const label = entry.category ? `${entry.keyword} (${entry.category})` : entry.keyword;
    byLocation[key].push(label);
  });
  return byLocation;
};

export const orderGeocodingResults = (distinctLocations, resultByKey) => {
  const ordered = [];
  distinctLocations.forEach((location) => {
    const result = resultByKey.get(location.toLowerCase());
    if (result) {
      ordered.push(result);
    }
  });
  return ordered;
};

export const geocodeInBatches = async ({
  countryCode,
  distinctLocations,
  cache,
  batchSize,
  geocodeRequest,
  onProgress,
}) => {
  const resultByKey = new Map();
  const toFetch = [];

  distinctLocations.forEach((location) => {
    const cacheKey = buildGeocodeCacheKey(countryCode, location);
    const cached = cache.get(cacheKey);
    if (cached) {
      resultByKey.set(location.toLowerCase(), cached);
    } else {
      toFetch.push(location);
    }
  });

  let resolvedCount = distinctLocations.length - toFetch.length;
  notifyProgress(onProgress, resolvedCount, distinctLocations, resultByKey);

  for (let start = 0; start < toFetch.length; start += batchSize) {
    const chunk = toFetch.slice(start, start + batchSize);
    const chunkResults = await geocodeRequest(countryCode, chunk);

    chunkResults.forEach((result) => {
      resultByKey.set(result.input.toLowerCase(), result);
      if (result.success) {
        const cacheKey = buildGeocodeCacheKey(countryCode, result.input);
        cache.set(cacheKey, result);
      }
    });

    resolvedCount += chunk.length;
    notifyProgress(onProgress, resolvedCount, distinctLocations, resultByKey);
  }

  return orderGeocodingResults(distinctLocations, resultByKey);
};

const notifyProgress = (onProgress, count, distinctLocations, resultByKey) => {
  if (!onProgress) return;
  const ordered = orderGeocodingResults(distinctLocations, resultByKey);
  onProgress(count, ordered);
};
